import { navbarTranslation } from "i18n/translateHelpers";
import { useBoundStore } from "state/bound.store";
import { useActiveNavBar } from "../navBar.store";
import { useDisabledTabProps } from "../tabDisabled.store";
import { TAB_BY_ID } from "../tabs";
import { NavBarItem } from "./navBarItem";

export const TeamNavBarItem = () => {
  const activeNavBar = useActiveNavBar();
  const teamPageEnabled = useBoundStore((s) => s.teamPageEnabled);
  const disabled = useDisabledTabProps("team");

  // Not in the disabled-tab store, so /team stays reachable by URL.
  const orgDisabled = !teamPageEnabled;

  return (
    <NavBarItem
      id="navbarItemTeam"
      label={navbarTranslation(TAB_BY_ID.team.label)}
      active={activeNavBar === "team"}
      path={TAB_BY_ID.team.route}
      icon={TAB_BY_ID.team.icon}
      {...disabled}
      disabled={orgDisabled || disabled.disabled}
      // Only the org case dims; a store-disabled tab responds to press.
      dimWhenDisabled={orgDisabled && !disabled.disabled}
    />
  );
};
